import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { InternshipChartsModel } from 'common/models/page-models/reports/internship-reports-model/internship-reports-charts.model';
import { InternshipReportsModel } from 'common/models/page-models/reports/internship-reports-model/internship-reports-data-model';
import { InternshipReportsListingModel } from 'common/models/page-models/reports/internship-reports-model/internship-reports-grid-model';
import { InternshipReportsGridPostParams } from 'common/models/page-models/reports/internship-reports-model/internship-reports-grid-params';


@Injectable({
    providedIn: 'root'
})
export class InternshipReportsDataService extends GridDataService<InternshipReportsListingModel, InternshipReportsModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.fetchReportData, http, ss);
    }

    createInstance(): InternshipReportsListingModel {
        return new InternshipReportsListingModel();
    }

    getDeleteUrl() {
        return '';
    }

    override getGridParams(param): GridPostParams {
        return new InternshipReportsGridPostParams();
    }

    override transformDataModel(data: any[], param: any) {
        super.transformDataModel(data, param);
        if(data.hasOwnProperty(param)) {
            data[param].forEach(element => {
                element.startDate = new Date(element.studentExpectedInternshipStartDate).toLocaleDateString();
                element.endDate = new Date(element.studentExpectedInternshipEndDate).toLocaleDateString();
    
            });
        }else{
            // console.log('No records found for given combination');
            this.ss.showError('No records found for given combination')
          }
        return data;
    }

    override getDataParam(): string {
        return 'details';
    }

    override modifyGridPostParams(queryParams) {
        let payload = this.getGridParams(queryParams);
        if (queryParams.transferData !== null) {
            payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
            payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
            payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
            payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
            payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
            payload['status_search'] = queryParams.transferData.selectedStatus === null ? '' : queryParams.transferData.selectedStatus;
            payload['internship_company_search'] = queryParams.transferData.selectedCompany === null ? '' : queryParams.transferData.selectedCompany;
            payload['considerYear_search'] = queryParams.transferData.selectedYear === null ? '' : queryParams.transferData.selectedYear;

        }
        return payload;
    }

    override prepareChartsData(apiData) {
        const chartsModel = new InternshipChartsModel();
        let continued = 0;
        let discontinued = 0;
        let completed = 0;
        let incompleted = 0;
        let notJoined = 0;

        apiData.forEach((key) => {
            if (key.OverallStatus === "Continued") {
                continued++;
              } else if (key.OverallStatus === "Discontinued") {
                discontinued++;
              } else if (key.OverallStatus === "Completed") {
                completed++;
              } else if (key.OverallStatus === "Incompleted") {
                incompleted++;
              } else if (key.OverallStatus === "Not Joined") {
                notJoined++
              }
        })
        const chartData = [
            {
              name: "Continued",
              y: continued,
              drilldown: "Continued",
              color: "#CC7F2B",
            },
            {
              name: "Discontinued",
              y: discontinued,
              drilldown: "Discontinued",
              color: "#9F8416",
            },
            {
              name: "Completed",
              y: completed,
              drilldown: "Completed",
              color: "#71841D",
            },
            {
              name: "Incompleted",
              y: incompleted,
              drilldown: "Incompleted",
              color: "#408032",
            },
            {
              name: "Not Joined, Incompleted",
              y: notJoined,
              drilldown: "Not Joined, Incompleted",
              color: "#006F5F",
            },
          ];

          chartsModel.studentStatusChart.options = {
            chart: {
                type: 'pie',
                width: 320, // Adjust chart width
                height: 300 // Adjust chart height
            },
            credits: {
                enabled: false // Disable the Highcharts credits
            },
            title: {
                text: 'Total Students:  ' + apiData.length,
                style: {
                    color: '#000000',
                    fontSize: '1.2em',
                }
            },
            series: [
                {
                    type: 'pie', // Add the type property here
                    data: chartData,
                    dataLabels: {
                        enabled: false,
                        inside: true,
                        distance: 6 // Adjust the distance of labels from the slices
                    }
                }
            ]
        };

        chartsModel.studentStatusChart.data = {
            continue: continued,
            continueColor: '#CC7F2B',
            disContinue: discontinued,
            disContinueColor: '#9F8416',
            complete: completed,
            completeColor: '#71841D',
            incomplete: incompleted,
            incompletedColor: '#408032',
            notJoined: notJoined,
            notJoinedColor: '#006F5F'
        }
        return chartsModel;
    }
}
